import { defaultStateType } from "../Store/defaultStatus";

export function reducer(state: any, action: any) {
  console.log('this is orderReducer!')

  switch (action.type) {
    case "REFILL":
      return { ...state, ...action.playload };
    default:
      return state;
  }
}


export function refillAction(object: defaultStateType) {
  return { type: "REFILL", playload: object };
}
